import React from "react";
import { Box, IconButton, Modal } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { object, string, bool, func, node } from "prop-types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  // p: 4,
} satisfies SxProps<Theme>;

type ModalBoxProps = React.PropsWithChildren<{
  sx?: SxProps<Theme>;
  crossColor?: string;
  open: boolean;
  handleClose: () => void;
}>;

export const ModalBox = (props: ModalBoxProps) => {
  // Use prop directly with fallback instead of state
  const crossColor = props.crossColor || "#000000";
  const modalSx = {
    ...style,
    ...(props.sx as Record<string, unknown>),
  } satisfies SxProps<Theme>;

  return (
    <div>
      <Modal open={props.open} onClose={props.handleClose}>
        <Box sx={modalSx}>
          <IconButton
            aria-label="close"
            onClick={props.handleClose}
            sx={{
              position: "absolute",
              zIndex: 2,
              right: 5,
              top: 5,
              color: () => crossColor,
            }}
          >
            <CloseIcon />
          </IconButton>
          {props.children}
        </Box>
      </Modal>
    </div>
  );
};

ModalBox.propTypes = {
  sx: object,
  crossColor: string,
  open: bool,
  handleClose: func,
  children: node,
};
